import { ContextNotification } from '@pandiafi/components'
import { Heading } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { RightOfOccupancyFeeWaitingForPayment } from '../../../../../common/generated/residentApiSchemas'
import { Divider } from '../../Divider'
import { localizeCurrency } from '../../utils'
import { FeeRow } from '../FeeRow/FeeRow'
import { FeeTotalRow } from '../FeeTotalRow/FeeTotalRow'

import { StyledLink } from 'components/StyledLink/StyledLink'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { formatDate } from 'utils/dateUtils'

export const WaitingForPaymentRightOfOccupancyFee: React.FC<{
  fee: RightOfOccupancyFeeWaitingForPayment
}> = ({ fee }) => {
  const { t } = useTranslation(['payments'])
  const { paymentInfoPath } = useContractPaths()
  const isPartiallyPaid = fee.paidAmount > 0

  return (
    <>
      <ContextNotification
        type="warning"
        icon="exclamation-triangle"
        rounded="m"
        className="mt-8 w-full"
      >
        {t('payments:rightOfOccupancyFee.notPaidWarning')}
      </ContextNotification>
      <section className="mt-8">
        <Heading element="h2" size="m" bold className="mb-2">
          {t('payments:rightOfOccupancyFee.payableTitle')}
        </Heading>
        <Divider />
        {isPartiallyPaid ? (
          <>
            <FeeRow
              label={t('payments:rightOfOccupancyFee.amountPayable')}
              value={localizeCurrency(fee.amountPayable)}
            />
            <FeeRow
              label={t('payments:rightOfOccupancyFee.paidAmount')}
              value={localizeCurrency(fee.paidAmount)}
            />
            <FeeRow
              label={t('payments:rightOfOccupancyFee.paidDate')}
              value={fee.paidDate ? formatDate(fee.paidDate) : '-'}
            />
            <Divider />
            <FeeTotalRow
              label={t('payments:rightOfOccupancyFee.remainingPayable')}
              value={localizeCurrency(fee.remainingPayable)}
            />
          </>
        ) : (
          <FeeTotalRow
            label={t('payments:rightOfOccupancyFee.amountPayable')}
            value={localizeCurrency(fee.amountPayable)}
          />
        )}
        <StyledLink to={paymentInfoPath} className="mt-2 inline-block">
          {t('payments:rightOfOccupancyFee.goToPaymentReferences')}
        </StyledLink>
      </section>
    </>
  )
}
